import { cn } from '@nexo/ui';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { RichText } from '../chat/RichText';
import { releaseNotes } from '../download/DownloadOptions';

/** Release notes: `- ` lines become a list, the rest paragraphs (with the chat's Markdown). */
export function ReleaseNotes({ notes, className }: { notes: string; className?: string }) {
  const { t } = useTranslation();
  const blocks: ReactNode[] = [];
  let items: string[] = [];
  const flush = () => {
    if (items.length === 0) return;
    blocks.push(
      <ul key={blocks.length} className="flex list-disc flex-col gap-1.5 pl-5 marker:text-subtle">
        {items.map((item, i) => (
          <li key={i}>
            <RichText text={item} />
          </li>
        ))}
      </ul>,
    );
    items = [];
  };
  for (const line of releaseNotes(notes).split('\n')) {
    const text = line.trim();
    const item = /^[-*•]\s+(.*)$/.exec(text);
    if (item) {
      items.push(item[1] ?? '');
      continue;
    }
    // Wrapped list lines (indented continuation) join the previous item.
    if (text && items.length > 0 && /^\s/.test(line)) {
      items = [...items.slice(0, -1), `${items.at(-1) ?? ''} ${text}`];
      continue;
    }
    flush();
    if (text) {
      blocks.push(
        <p key={blocks.length}>
          <RichText text={text} />
        </p>,
      );
    }
  }
  flush();
  if (blocks.length === 0) return <p className="text-muted">{t('Mejoras y correcciones.')}</p>;
  return (
    <div className={cn('flex flex-col gap-2 text-sm leading-relaxed', className)}>{blocks}</div>
  );
}
